import surveyPointReducer from "./surveyPointReducer";
import surveyCommentTagReducer from "./surveyCommentTagReducer";
import { combineReducers } from "redux";

const allReducers = combineReducers({
  surveyPoint: surveyPointReducer,
  surveyCommentTag: surveyCommentTagReducer,
});

export default allReducers;
